export default "__VITE_ASSET__B_D5QQYr__"